export default axios => ({
  getBrands(brands = '') {
    try {
      return axios.$get(`/v1/brands/${brands}`);
    } catch (error) {
      throw new Error(`API Request Error (getBrands): ${error}`);
    }
  },
});
